import { controlsFactory } from './factory';
import {
    FILTERS_RELOAD,
    FILTERS_SET_CONTROLS,
    FILTERS_SET_RELOAD,
    FILTERS_SET_VALUES,
    FILTERS_UPDATE_CONTROLS,
    FILTERS_UPDATE_VALUES
} from './types';

export const actions = {
    [FILTERS_RELOAD]: ({ state, commit }) => {
        commit(FILTERS_SET_RELOAD, !state.reload);
    },
    [FILTERS_UPDATE_VALUES]: ({ commit }, payload) => {
        commit(FILTERS_SET_VALUES, payload);
    },
    [FILTERS_UPDATE_CONTROLS]: ({ commit }, payload) => {
        commit(FILTERS_SET_CONTROLS, controlsFactory(payload).getData());
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/actions.js